import React from "react";
import InviteYourTeam from "./InviteYourTeam";

// image
import user from "../../../assets/images/user.png"
import slack from "../../../assets/images/slack.svg"
import avatar6 from "../../../assets/images/avatar-6.png"
import avatar7 from "../../../assets/images/avatar-7.png"
import avatar8 from "../../../assets/images/avatar-8.png"
import behance from "../../../assets/images/behance.png"
import chatgpt from "../../../assets/images/chatgpt.png"
import { Link } from "react-router-dom";

const MainContent = ({ activeTab, selectedMail, toggleMail }: any) => {
  return (
    <React.Fragment>
      <div className="flex-1 w-full tab-content md:w-auto">
        {/* compose */}
        {activeTab === "compose" && (
          <div
            className="flex flex-col items-start lg:flex-row gap-7"
          >
            <div className="flex-1 md:h-[calc(100vh-210px)] w-full overflow-y-auto space-y-4">
              <div className="bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
                <div className="py-2.5 px-4 border-b border-black/10 dark:border-darkborder flex flex-wrap items-center gap-y-3 gap-x-12">
                  <p className="text-muted dark:text-white">TO</p>
                  <div className="flex flex-wrap gap-2">
                    <div className="flex gap-2 p-1 rounded cursor-pointer bg-light/20 dark:bg-white/5">
                      <img
                        className="flex-none object-cover w-6 h-6 overflow-hidden rounded"
                        src={user}
                        alt=""
                      />
                      <div className="flex items-center justify-between flex-1 gap-2">
                        <p>Stevens</p>
                        <Link
                          to="#"
                          className="text-muted hover:text-black"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            className="w-4 h-4"
                          >
                            <path
                              fill="currentColor"
                              d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                            ></path>
                          </svg>
                        </Link>
                      </div>
                    </div>
                    <div className="flex gap-2 p-1 rounded bg-light/20 dark:bg-white/5">
                      <img
                        className="flex-none object-cover w-6 h-6 overflow-hidden rounded-full"
                        src={slack}
                        alt=""
                      />
                      <div className="flex items-center justify-between flex-1 gap-2">
                        <p>Slack</p>
                        <Link
                          to="#"
                          className="text-muted hover:text-black"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            className="w-4 h-4"
                          >
                            <path
                              fill="currentColor"
                              d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                            ></path>
                          </svg>
                        </Link>
                      </div>
                    </div>
                    <div className="flex gap-2 p-1 rounded-lg bg-light/20 dark:bg-white/5">
                      <div className="flex items-center justify-between flex-1 gap-2">
                        <p>support@mail.com</p>
                        <Link
                          to="#"
                          className="text-muted hover:text-black"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            className="w-4 h-4"
                          >
                            <path
                              fill="currentColor"
                              d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                            ></path>
                          </svg>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex gap-4 p-4">
                  <p className="text-muted dark:text-white">Subject</p>
                  <p>Introducing the Snow Dashboard UI Kit</p>
                </div>
              </div>
              <div className="relative">
                <div
                  className="text-black"
                  x-data="app()"
                  x-init="init($refs.sliced)"
                >
                  <div className="overflow-hidden bg-white border rounded-md border-black/10 dark:bg-darklight dark:border-darkborder">
                    <div className="flex flex-wrap w-full border-b border-black/10 dark:border-darkborder">
                      <button className="w-10 h-10 text-black outline-none focus:outline-none dark:text-white dark:hover:text-purple hover:text-purple active:bg-light/50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 mx-auto"
                        >
                          <path
                            d="M8 11H12.5C13.8807 11 15 9.88071 15 8.5C15 7.11929 13.8807 6 12.5 6H8V11ZM18 15.5C18 17.9853 15.9853 20 13.5 20H6V4H12.5C14.9853 4 17 6.01472 17 8.5C17 9.70431 16.5269 10.7981 15.7564 11.6058C17.0979 12.3847 18 13.837 18 15.5ZM8 13V18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H8Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <button
                        className="w-10 h-10 text-black outline-none focus:outline-none dark:text-white dark:hover:text-purple hover:text-purple active:bg-light/50"
                        // @click="format('italic')"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 mx-auto"
                        >
                          <path
                            d="M15 20H7V18H9.92661L12.0425 6H9V4H17V6H14.0734L11.9575 18H15V20Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <button className="w-10 h-10 mr-1 text-black outline-none focus:outline-none dark:text-white dark:hover:text-purple hover:text-purple active:bg-light/50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 mx-auto"
                        >
                          <path
                            d="M8 3V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V3H18V12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12V3H8ZM4 20H20V22H4V20Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <button className="w-10 h-10 text-black outline-none focus:outline-none dark:text-white dark:hover:text-purple hover:text-purple active:bg-light/50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 mx-auto"
                        >
                          <path
                            d="M12 6V21H10V16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4H20V6H17V21H15V6H12ZM10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14V6Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <button className="w-10 h-10 text-black outline-none focus:outline-none dark:text-white dark:hover:text-purple hover:text-purple active:bg-light/50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 mx-auto"
                        >
                          <path
                            d="M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM21.0005 8V20H19.0005L19 10.204L17 10.74V8.67L19.5005 8H21.0005Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <button className="w-10 h-10 text-black outline-none focus:outline-none dark:text-white dark:hover:text-purple hover:text-purple active:bg-light/50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 mx-auto"
                        >
                          <path
                            d="M4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 8C20.5711 8 22.25 9.67893 22.25 11.75C22.25 12.6074 21.9623 13.3976 21.4781 14.0292L21.3302 14.2102L18.0343 18H22V20H15L14.9993 18.444L19.8207 12.8981C20.0881 12.5908 20.25 12.1893 20.25 11.75C20.25 10.7835 19.4665 10 18.5 10C17.5818 10 16.8288 10.7071 16.7558 11.6065L16.75 11.75H14.75C14.75 9.67893 16.4289 8 18.5 8Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <button className="w-10 h-10 mr-1 text-black outline-none focus:outline-none dark:text-white dark:hover:text-purple hover:text-purple active:bg-light/50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 mx-auto"
                        >
                          <path
                            d="M22 8L21.9984 10L19.4934 12.883C21.0823 13.3184 22.25 14.7728 22.25 16.5C22.25 18.5711 20.5711 20.25 18.5 20.25C16.674 20.25 15.1528 18.9449 14.8184 17.2166L16.7821 16.8352C16.9384 17.6413 17.6481 18.25 18.5 18.25C19.4665 18.25 20.25 17.4665 20.25 16.5C20.25 15.5335 19.4665 14.75 18.5 14.75C18.214 14.75 17.944 14.8186 17.7056 14.9403L16.3992 13.3932L19.3484 10H15V8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <button className="w-10 h-10 text-black outline-none focus:outline-none dark:text-white dark:hover:text-purple hover:text-purple active:bg-light/50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 mx-auto"
                        >
                          <path
                            d="M11 4H21V6H11V4ZM11 8H17V10H11V8ZM11 14H21V16H11V14ZM11 18H17V20H11V18ZM3 4H9V10H3V4ZM5 6V8H7V6H5ZM3 14H9V20H3V14ZM5 16V18H7V16H5Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <button className="w-10 h-10 mr-1 text-black outline-none focus:outline-none dark:text-white dark:hover:text-purple hover:text-purple active:bg-light/50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 mx-auto"
                        >
                          <path
                            d="M5.75024 3.5H4.71733L3.25 3.89317V5.44582L4.25002 5.17782L4.25018 8.5H3V10H7V8.5H5.75024V3.5ZM10 4H21V6H10V4ZM10 11H21V13H10V11ZM10 18H21V20H10V18ZM2.875 15.625C2.875 14.4514 3.82639 13.5 5 13.5C6.17361 13.5 7.125 14.4514 7.125 15.625C7.125 16.1106 6.96183 16.5587 6.68747 16.9167L6.68271 16.9229L5.31587 18.5H7V20H3.00012L2.99959 18.8786L5.4717 16.035C5.5673 15.9252 5.625 15.7821 5.625 15.625C5.625 15.2798 5.34518 15 5 15C4.67378 15 4.40573 15.2501 4.37747 15.5688L4.3651 15.875H2.875V15.625Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <button className="w-10 h-10 text-black outline-none focus:outline-none dark:text-white dark:hover:text-purple hover:text-purple active:bg-light/50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 mx-auto"
                        >
                          <path
                            d="M3 4H21V6H3V4ZM3 19H17V21H3V19ZM3 14H21V16H3V14ZM3 9H17V11H3V9Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <button className="w-10 h-10 text-black outline-none focus:outline-none dark:text-white dark:hover:text-purple hover:text-purple active:bg-light/50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 mx-auto"
                        >
                          <path
                            d="M3 4H21V6H3V4ZM3 19H21V21H3V19ZM3 14H21V16H3V14ZM3 9H21V11H3V9Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                      <button className="w-10 h-10 text-black outline-none focus:outline-none dark:text-white dark:hover:text-purple hover:text-purple active:bg-light/50">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          className="w-5 h-5 mx-auto"
                        >
                          <path
                            d="M3 4H21V6H3V4ZM7 19H21V21H7V19ZM3 14H21V16H3V14ZM7 9H21V11H7V9Z"
                            fill="currentColor"
                          ></path>
                        </svg>
                      </button>
                    </div>
                    <div className="w-full">
                      <iframe
                      title="abc"
                        x-ref="sliced"
                        className="w-full min-h-[calc(100vh-542px)] md:min-h-[calc(100vh-452px)] overflow-y-auto text-editor"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-4 py-2 bg-white border rounded-md border-black/10 dark:bg-darklight dark:border-darkborder">
                <div className="flex items-center justify-between gap-2">
                  <div className="flex items-center gap-2">
                    <div className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded cursor-pointer sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-5 h-5"
                      >
                        <path
                          fill="currentColor"
                          d="M4 8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8ZM6 10V20H18V10H6ZM9 12H11V18H9V12ZM13 12H15V18H13V12ZM7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9Z"
                        ></path>
                      </svg>
                    </div>
                    <div className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded cursor-pointer sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-5 h-5"
                      >
                        <path
                          fill="currentColor"
                          d="M2.9918 21C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918ZM20 15V5H4V19L14 9L20 15ZM20 17.8284L14 11.8284L6.82843 19H20V17.8284ZM8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11Z"
                        ></path>
                      </svg>
                    </div>
                    <div className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded cursor-pointer sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-5 h-5"
                      >
                        <path
                          fill="currentColor"
                          d="M14.8287 7.7574L9.1718 13.4143C8.78127 13.8048 8.78127 14.4379 9.1718 14.8285C9.56232 15.219 10.1955 15.219 10.586 14.8285L16.2429 9.17161C17.4144 8.00004 17.4144 6.10055 16.2429 4.92897C15.0713 3.7574 13.1718 3.7574 12.0002 4.92897L6.34337 10.5858C4.39075 12.5384 4.39075 15.7043 6.34337 17.6569C8.29599 19.6095 11.4618 19.6095 13.4144 17.6569L19.0713 12L20.4855 13.4143L14.8287 19.0711C12.095 21.8048 7.66283 21.8048 4.92916 19.0711C2.19549 16.3374 2.19549 11.9053 4.92916 9.17161L10.586 3.51476C12.5386 1.56214 15.7045 1.56214 17.6571 3.51476C19.6097 5.46738 19.6097 8.63321 17.6571 10.5858L12.0002 16.2427C10.8287 17.4143 8.92916 17.4143 7.75759 16.2427C6.58601 15.0711 6.58601 13.1716 7.75759 12L13.4144 6.34319L14.8287 7.7574Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      className="btn bg-light border border-light rounded-md text-black transition-all duration-300 hover:bg-light/[0.85] hover:border-light/[0.85]"
                    >
                      Save draft
                    </button>
                    <button
                      type="button"
                      className="btn py-2.5 px-3 bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-5 h-5"
                      >
                        <path
                          fill="currentColor"
                          d="M3.5 1.3457C3.58425 1.3457 3.66714 1.36699 3.74096 1.4076L22.2034 11.562C22.4454 11.695 22.5337 11.9991 22.4006 12.241C22.3549 12.3241 22.2865 12.3925 22.2034 12.4382L3.74096 22.5925C3.499 22.7256 3.19497 22.6374 3.06189 22.3954C3.02129 22.3216 3 22.2387 3 22.1544V1.8457C3 1.56956 3.22386 1.3457 3.5 1.3457ZM5 4.38261V11.0001H10V13.0001H5V19.6175L18.8499 12.0001L5 4.38261Z"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* inbox */}
        {activeTab === "inbox" && (
          <div
            x-data="{selectedMail: false}"
            className="relative flex flex-row items-start gap-4"
          >
            <div className="lg:max-w-[300px] xl:max-w-[426px] w-full flex-1 flex flex-col gap-2 rounded border border-black/10 dark:bg-darklight dark:border-darkborder bg-white min-h-[calc(100vh-340px)] md:min-h-[calc(100vh-212px)]">
              <div className="flex items-center justify-between gap-2 px-4 py-2 bg-light/20 dark:bg-white/5">
                <div className="flex items-center gap-2">
                  <div>
                    <input
                      type="checkbox"
                      className="form-checkbox outborder-purple"
                    />
                  </div>
                  <div className="relative w-full max-w-[160px]">
                    <input
                      type="text"
                      className="h-10 form-input dark:text-white/80 dark:placeholder:text-white/30 dark:border-darkborder dark:bg-dark dark:focus:border-white/30"
                      placeholder="Search..."
                      required
                    />
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26ZM12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502L9.96214 9.69434L5.12921 10.2674L8.70231 13.5717L7.75383 18.3451L12.0006 15.968Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M4 8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8ZM6 10V20H18V10H6ZM9 12H11V18H9V12ZM13 12H15V18H13V12ZM7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9Z"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div className="space-y-2 py-1.5 px-4 overflow-y-auto">
                <button
                  onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/50 dark:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={avatar6}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">
                        Natali Craig
                      </p>
                      <p className="text-xs text-muted line-clamp-1">
                        Are you free tonight?
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-white">
                      19:28
                    </p>
                    <div className="text-muted hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
                <button
                  onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={slack}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">Slack</p>
                      <p className="text-xs text-muted line-clamp-1">
                        Invite your team to Slack
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-darkmuted">
                      18:30
                    </p>
                    <div className="text-purple hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
                <button
                  onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={avatar7}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">Drew Cano</p>
                      <p className="text-xs text-muted line-clamp-1">
                        Let's go fishing! - Hey, You wanna join me and Fred at
                        the lake tomorrow? It'll be awesome.
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-darkmuted">
                      17:30
                    </p>
                    <div className="text-muted hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
                <button
                 onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={avatar8}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">
                        Orlando Diggs
                      </p>
                      <p className="text-xs text-muted line-clamp-1">
                        Hey man – Nah man sorry i don't. Should i get it?
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-darkmuted">
                      15:30
                    </p>
                    <div className="text-muted hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
                <button
                  onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={behance}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">Behance</p>
                      <p className="text-xs text-muted line-clamp-1">
                        You have a new follower
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-darkmuted">
                      15:25
                    </p>
                    <div className="text-purple hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
                <button
                 onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={chatgpt}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">ChatGPT</p>
                      <p className="text-xs text-muted line-clamp-1">
                        Welcome to ChatGPT
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-darkmuted">
                      April 12
                    </p>
                    <div className="text-muted hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
              </div>
            </div>
            {/* Invite team */}
            <InviteYourTeam selectedMail={selectedMail} toggleMail={toggleMail} />
          </div>
        )}
        {/* sent */}
        {activeTab === "sent" && (
          <div
            x-data="{selectedMail: false}"
            className="relative flex flex-row items-start gap-4"
          >
            <div className="lg:max-w-[300px] xl:max-w-[426px] w-full flex-1 flex flex-col gap-2 rounded border border-black/10 dark:bg-darklight dark:border-darkborder bg-white min-h-[calc(100vh-340px)] md:min-h-[calc(100vh-212px)]">
              <div className="flex items-center justify-between gap-2 px-4 py-2 bg-light/20 dark:bg-white/5">
                <div className="flex items-center gap-2">
                  <div>
                    <input
                      type="checkbox"
                      className="form-checkbox outborder-purple"
                    />
                  </div>
                  <div className="relative w-full max-w-[160px]">
                    <input
                      type="text"
                      className="h-10 form-input dark:text-white/80 dark:placeholder:text-white/30 dark:border-darkborder dark:bg-dark dark:focus:border-white/30"
                      placeholder="Search..."
                      required
                    />
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26ZM12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502L9.96214 9.69434L5.12921 10.2674L8.70231 13.5717L7.75383 18.3451L12.0006 15.968Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M4 8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8ZM6 10V20H18V10H6ZM9 12H11V18H9V12ZM13 12H15V18H13V12ZM7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9Z"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div className="space-y-2 py-1.5 px-4 overflow-y-auto">
                <button
                 onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={chatgpt}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">ChatGPT</p>
                      <p className="text-xs text-muted line-clamp-1">
                        Welcome to ChatGPT
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-darkmuted">
                      April 12
                    </p>
                    <div className="text-muted hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
              </div>
            </div>
            {/* Invite team */}
            <InviteYourTeam selectedMail={selectedMail} toggleMail={toggleMail} />
          </div>
        )}
        {/* draft */}
        {activeTab === "draft" && (
          <div
            x-data="{selectedMail: false}"
            className="relative flex flex-row items-start gap-4"
          >
            <div className="lg:max-w-[300px] xl:max-w-[426px] w-full flex-1 flex flex-col gap-2 rounded border border-black/10 dark:bg-darklight dark:border-darkborder bg-white min-h-[calc(100vh-340px)] md:min-h-[calc(100vh-212px)]">
              <div className="flex items-center justify-between gap-2 px-4 py-2 bg-light/20 dark:bg-white/5">
                <div className="flex items-center gap-2">
                  <div>
                    <input
                      type="checkbox"
                      className="form-checkbox outborder-purple"
                    />
                  </div>
                  <div className="relative w-full max-w-[160px]">
                    <input
                      type="text"
                      className="h-10 form-input dark:text-white/80 dark:placeholder:text-white/30 dark:border-darkborder dark:bg-dark dark:focus:border-white/30"
                      placeholder="Search..."
                      required
                    />
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26ZM12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502L9.96214 9.69434L5.12921 10.2674L8.70231 13.5717L7.75383 18.3451L12.0006 15.968Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M4 8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8ZM6 10V20H18V10H6ZM9 12H11V18H9V12ZM13 12H15V18H13V12ZM7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9Z"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div className="space-y-2 py-1.5 px-4 overflow-y-auto">
                <button
                 onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={slack}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">Slack</p>
                      <p className="text-xs text-muted line-clamp-1">
                        Invite your team to Slack
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-darkmuted">
                      18:30
                    </p>
                    <div className="text-purple hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
                <button
                 onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={chatgpt}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">ChatGPT</p>
                      <p className="text-xs text-muted line-clamp-1">
                        Welcome to ChatGPT
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-darkmuted">
                      April 12
                    </p>
                    <div className="text-muted hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
              </div>
            </div>
            {/* Invite team */}
            <InviteYourTeam selectedMail={selectedMail} toggleMail={toggleMail} />
          </div>
        )}
        {/* spam */}
        {activeTab === "spam" && (
          <div
            x-data="{selectedMail: false}"
            className="relative flex flex-row items-start gap-4"
          >
            <div className="lg:max-w-[300px] xl:max-w-[426px] w-full flex-1 flex flex-col gap-2 rounded border border-black/10 dark:bg-darklight dark:border-darkborder bg-white min-h-[calc(100vh-340px)] md:min-h-[calc(100vh-212px)]">
              <div className="flex items-center justify-between gap-2 px-4 py-2 bg-light/20 dark:bg-white/5">
                <div className="flex items-center gap-2">
                  <div>
                    <input
                      type="checkbox"
                      className="form-checkbox outborder-purple"
                    />
                  </div>
                  <div className="relative w-full max-w-[160px]">
                    <input
                      type="text"
                      className="h-10 form-input dark:text-white/80 dark:placeholder:text-white/30 dark:border-darkborder dark:bg-dark dark:focus:border-white/30"
                      placeholder="Search..."
                      required
                    />
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26ZM12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502L9.96214 9.69434L5.12921 10.2674L8.70231 13.5717L7.75383 18.3451L12.0006 15.968Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M4 8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8ZM6 10V20H18V10H6ZM9 12H11V18H9V12ZM13 12H15V18H13V12ZM7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9Z"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div className="space-y-2 py-1.5 px-4 overflow-y-auto">
                <button
                 onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/50 dark:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={avatar6}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">
                        Natali Craig
                      </p>
                      <p className="text-xs text-muted line-clamp-1">
                        Are you free tonight?
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-white">
                      19:28
                    </p>
                    <div className="text-muted hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
                <button
                 onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={slack}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">Slack</p>
                      <p className="text-xs text-muted line-clamp-1">
                        Invite your team to Slack
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-darkmuted">
                      18:30
                    </p>
                    <div className="text-purple hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
                <button
                 onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={chatgpt}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">ChatGPT</p>
                      <p className="text-xs text-muted line-clamp-1">
                        Welcome to ChatGPT
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-darkmuted">
                      April 12
                    </p>
                    <div className="text-muted hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
              </div>
            </div>
            {/* Invite team */}
            <InviteYourTeam selectedMail={selectedMail} toggleMail={toggleMail} />
          </div>
        )}
        {/* trash */}
        {activeTab === "trash" && (
          <div
            x-data="{selectedMail: false}"
            className="relative flex flex-row items-start gap-4"
          >
            <div className="lg:max-w-[300px] xl:max-w-[426px] w-full flex-1 flex flex-col gap-2 rounded border border-black/10 dark:bg-darklight dark:border-darkborder bg-white min-h-[calc(100vh-340px)] md:min-h-[calc(100vh-212px)]">
              <div className="flex items-center justify-between gap-2 px-4 py-2 bg-light/20 dark:bg-white/5">
                <div className="flex items-center gap-2">
                  <div>
                    <input
                      type="checkbox"
                      className="form-checkbox outborder-purple"
                    />
                  </div>
                  <div className="relative w-full max-w-[160px]">
                    <input
                      type="text"
                      className="h-10 form-input dark:text-white/80 dark:placeholder:text-white/30 dark:border-darkborder dark:bg-dark dark:focus:border-white/30"
                      placeholder="Search..."
                      required
                    />
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26ZM12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502L9.96214 9.69434L5.12921 10.2674L8.70231 13.5717L7.75383 18.3451L12.0006 15.968Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M4 8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8ZM6 10V20H18V10H6ZM9 12H11V18H9V12ZM13 12H15V18H13V12ZM7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9Z"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div className="space-y-2 py-1.5 px-4 overflow-y-auto">
                <button
                 onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={avatar8}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">
                        Orlando Diggs
                      </p>
                      <p className="text-xs text-muted line-clamp-1">
                        Hey man – Nah man sorry i don't. Should i get it?
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-darkmuted">
                      15:30
                    </p>
                    <div className="text-muted hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
              </div>
            </div>
            {/* Invite team */}
            <InviteYourTeam selectedMail={selectedMail} toggleMail={toggleMail} />
          </div>
        )}
        {/* archive */}
        {activeTab === "archive" && (
          <div
            x-data="{selectedMail: false}"
            className="relative flex flex-row items-start gap-4"
          >
            <div className="lg:max-w-[300px] xl:max-w-[426px] w-full flex-1 flex flex-col gap-2 rounded border border-black/10 dark:bg-darklight dark:border-darkborder bg-white min-h-[calc(100vh-340px)] md:min-h-[calc(100vh-212px)]">
              <div className="flex items-center justify-between gap-2 px-4 py-2 bg-light/20 dark:bg-white/5">
                <div className="flex items-center gap-2">
                  <div>
                    <input
                      type="checkbox"
                      className="form-checkbox outborder-purple"
                    />
                  </div>
                  <div className="relative w-full max-w-[160px]">
                    <input
                      type="text"
                      className="h-10 form-input dark:text-white/80 dark:placeholder:text-white/30 dark:border-darkborder dark:bg-dark dark:focus:border-white/30"
                      placeholder="Search..."
                      required
                    />
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26ZM12.0006 15.968L16.2473 18.3451L15.2988 13.5717L18.8719 10.2674L14.039 9.69434L12.0006 5.27502L9.96214 9.69434L5.12921 10.2674L8.70231 13.5717L7.75383 18.3451L12.0006 15.968Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z"
                      ></path>
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      className="w-5 h-5"
                    >
                      <path
                        fill="currentColor"
                        d="M4 8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8ZM6 10V20H18V10H6ZM9 12H11V18H9V12ZM13 12H15V18H13V12ZM7 5V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V5H22V7H2V5H7ZM9 4V5H15V4H9Z"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div className="space-y-2 py-1.5 px-4 overflow-y-auto">
                <button
                 onClick={() => toggleMail(true)}
                  className="flex items-start w-full gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50"
                >
                  <div className="flex items-center flex-1 gap-2 p-1">
                    <div>
                      <input
                        type="checkbox"
                        className="form-checkbox outborder-purple"
                      />
                    </div>
                    <img
                      className="flex-none object-cover overflow-hidden rounded-full w-9 h-9"
                      src={avatar7}
                      alt=""
                    />
                    <div className="flex-1 ltr:text-left rtl:text-right">
                      <p className="line-clamp-1 dark:text-white">Drew Cano</p>
                      <p className="text-xs text-muted line-clamp-1">
                        Let's go fishing! - Hey, You wanna join me and Fred at
                        the lake tomorrow? It'll be awesome.
                      </p>
                    </div>
                  </div>
                  <div>
                    <p className="flex-none text-xs text-black/40 mb-1.5 dark:text-darkmuted">
                      17:30
                    </p>
                    <div className="text-muted hover:text-purple">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        className="w-4 h-4 mx-auto"
                      >
                        <path
                          fill="currentColor"
                          d="M12.0006 18.26L4.94715 22.2082L6.52248 14.2799L0.587891 8.7918L8.61493 7.84006L12.0006 0.5L15.3862 7.84006L23.4132 8.7918L17.4787 14.2799L19.054 22.2082L12.0006 18.26Z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </button>
              </div>
            </div>
            {/* Invite team */}
            <InviteYourTeam selectedMail={selectedMail} toggleMail={toggleMail} />
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default MainContent;
